import { useLazyQuery } from "@apollo/client";
import { useEffect } from "react";
import { useIntl } from "react-intl";

import TimeLogForm from "@components/forms/TimeLogForm";
import HandleQuery from "@components/HandleQuery";
import Modal from "@components/Modal";
import useGlobalOpener from "@hooks/useGlobalOpener";
import { OpenerTypeEnum } from "@typing/Enums";
import {
  GetJourneyWithTimeLogsDocument,
  GetJourneyWithTimeLogsQuery,
  GetJourneyWithTimeLogsQueryVariables
} from "@typing/Generated";

type Props = {
  journeyId: string;
};

const TimeLogModal = ({ journeyId }: Props) => {
  const timeTrackingOpener = useGlobalOpener(OpenerTypeEnum.TIME_LOG);
  const intl = useIntl();

  const [getJourney, getJourneyQuery] = useLazyQuery<GetJourneyWithTimeLogsQuery, GetJourneyWithTimeLogsQueryVariables>(
    GetJourneyWithTimeLogsDocument
  );

  useEffect(() => {
    if (timeTrackingOpener.isOpen) {
      getJourney({
        variables: {
          id: journeyId
        }
      });
    }
  }, [getJourney, journeyId, timeTrackingOpener.isOpen]);

  return (
    <Modal
      cssClass="fullscreen"
      dataCy="time-log-modal"
      opener={timeTrackingOpener}
      title={intl.formatMessage({
        id: "models.timeLog.addTimeLog"
      })}
    >
      {({ modalDisplayed }) => (
        <HandleQuery query={getJourneyQuery}>
          {data => (
            <TimeLogForm
              autofocus={modalDisplayed}
              journey={data.journey}
              onSuccess={timeTrackingOpener.close}
              refetch={getJourneyQuery.refetch}
            />
          )}
        </HandleQuery>
      )}
    </Modal>
  );
};

export default TimeLogModal;
